import React, { useState, useRef, useEffect, useCallback } from 'react';
import { api } from '../api';

const MARKET_SHORT = {
  MIL: 'Milano', NYSE: 'NYSE', NASDAQ: 'NASDAQ',
  XETRA: 'XETRA', PARIS: 'Parigi', LSE: 'Londra', RAW: 'Altro',
};

export default function SearchBox({ onSelect }) {
  const [query, setQuery]     = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [active, setActive]   = useState(-1);
  const boxRef   = useRef(null);
  const timerRef = useRef(null);

  // Chiudi il dropdown cliccando fuori
  useEffect(() => {
    const onClick = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  // Ricerca con debounce
  const runSearch = useCallback((q) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    if (q.trim().length < 2) { setResults([]); setOpen(false); return; }
    timerRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const r = await api.search(q.trim());
        setResults(r); setOpen(true); setActive(-1);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 350);
  }, []);

  const onChange = (e) => { setQuery(e.target.value); runSearch(e.target.value); };

  const pick = (r) => {
    setQuery(''); setResults([]); setOpen(false);
    onSelect({ ticker: r.ticker, market: r.market, name: r.name });
  };

  const onKeyDown = (e) => {
    if (!open || results.length === 0) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(a => Math.min(a + 1, results.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(a => Math.max(a - 1, 0)); }
    else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); pick(results[active]); }
    else if (e.key === 'Escape') setOpen(false);
  };

  return (
    <div ref={boxRef} style={{ position: 'relative', width: '100%', maxWidth: 360 }}>
      <input
        value={query}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={() => results.length && setOpen(true)}
        placeholder="Cerca qualsiasi titolo nel mondo… (es. Apple, ENI, Toyota)"
        style={{
          width: '100%', fontSize: 13, padding: '8px 14px',
          background: '#131720', border: '1px solid #1e2736', borderRadius: 10,
          color: '#e2e8f0', outline: 'none',
        }}
        onFocusCapture={e => e.target.style.borderColor = '#2563eb60'}
        onBlur={e => e.target.style.borderColor = '#1e2736'}
      />
      {loading && (
        <span style={{ position: 'absolute', right: 12, top: 9, fontSize: 12, color: '#475569' }}>…</span>
      )}
      {open && results.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4,
          background: '#0d1117', border: '1px solid #1e2736', borderRadius: 10,
          maxHeight: 320, overflowY: 'auto', zIndex: 300,
          boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
        }}>
          {results.map((r, i) => (
            <button
              key={r.symbol + i}
              onClick={() => pick(r)}
              onMouseEnter={() => setActive(i)}
              style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                width: '100%', padding: '9px 14px', cursor: 'pointer', textAlign: 'left',
                background: active === i ? '#1e2736' : 'transparent', border: 'none',
                borderBottom: '1px solid #161c28',
              }}>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#e2e8f0', fontFamily: "'IBM Plex Mono', monospace" }}>
                  {r.symbol}
                </div>
                <div style={{ fontSize: 11, color: '#475569', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 230 }}>
                  {r.name}
                </div>
              </div>
              <span style={{ fontSize: 10, color: '#64748b', background: '#161c28', padding: '2px 8px', borderRadius: 20, flexShrink: 0, marginLeft: 8 }}>
                {MARKET_SHORT[r.market] || r.exchange}
              </span>
            </button>
          ))}
        </div>
      )}
      {open && !loading && results.length === 0 && query.trim().length >= 2 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 4,
          background: '#0d1117', border: '1px solid #1e2736', borderRadius: 10,
          padding: '12px 14px', fontSize: 12, color: '#475569', zIndex: 300,
        }}>
          Nessun titolo trovato per “{query}”.
        </div>
      )}
    </div>
  );
}
